import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class BringozChipsComponent implements IController {
  items: any;
  ngPlaceholder: string;
  isRequired: any;
  name: string;
  onChange: Function;

  private selectedChips: any;

  constructor() {
  }

  $onInit() {
    this.initChips();

    if (!this.name) {
      this.name = 'referenceIds'
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.initChips();
    }
  }

  transformChip(chip) {
    // If it is an object, it's already a known chip
    if (angular.isObject(chip)) {
      return;
    }
    // Otherwise, create a new one
    return {name: chip}
  }

  updateReferenceIds() {
    const selectedItems = _.map(this.selectedChips, (c) => {
      return c.name;
    })
    this.onChange({items: selectedItems})
  }

  private initChips() {
    this.selectedChips = _.map(this.items, t => {
      return {name: t}
    });
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozChips', {
    require: {
      form: '^form'
    },
    bindings: {
      items: '<?',
      ngPlaceholder: '@?',
      name: '@?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./bringoz-chips.html').default,
    controller: BringozChipsComponent
  });
